import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IOAuthLinkSystemJob } from '../../extViewmodels/sdk/models/Ads';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useConnectMetaLeads = ({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (value: IOAuthLinkSystemJob) => void;
}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: () => {
			return userSession.webServiceHelper.callAsync<IOAuthLinkSystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext: userSession.impersonationContext,
					urlPath: 'ads/providers/meta/authUrl',
				}),
				'POST',
				null
			);
		},
		onError,
		onSuccess,
	});
};
